var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-wrap so-month-event-template",style:({
    'background-color':
      _vm.data.WOType === 'Maintenance' ? 'gray' : _vm.data.TransportStatusHexColour,
  })},[_c('div',{staticClass:"subject"},[_c('span',[_vm._v(_vm._s(_vm.data.subject))]),_c('span',[_vm._v(_vm._s(_vm.data.WorkOrderFriendlyStatus))])]),_c('div',{staticClass:"description"},[_c('span',[_vm._v("SO # "+_vm._s(_vm.data.SalesOrderCode))]),_c('span',[_vm._v(_vm._s(_vm.data.ProductCode))])]),(_vm.data.HasNote === 'Y')?_c('GcCommentIcon',{staticClass:"calendar-comment"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }